if (Scoop.userId) {
    window.ScoopNotification = {
        showToast: function (data) {
            var options = {
                timeOut: 5000,
                newestOnTop: true,
                positionClass: 'toast-bottom-left animated fadeInUp',
                preventDuplicates: false,
                preventOpenDuplicates: false
            };

            toastr[data.type](data.text, data.headline, options);
        }
    };

    // window.Echo.private('Notify.Others')
    //     .listen('.ScoopNotification', function (e) {
    //         if (typeof ScoopNotification[e.method] === 'function') {
    //             ScoopNotification[e.method](e.data);
    //         } else {
    //             console.log(e.method + ' does not exist in ScoopNotification');
    //         }
    //     });

    window.Echo.private('Notify.User.' + Scoop.userId)
        .listen('.ScoopNotification', function (e) {
            if (typeof ScoopNotification[e.method] === 'function') {
                ScoopNotification[e.method](e.data);
            } else {
                console.log(e.method + ' does not exist in ScoopNotification');
            }
        });

    window.Echo.private('Notify.Role.Superadmin')
        .listen('.Scoop\\Events\\QueueUpdated', function (e) {
            Scoop.queue.setQueueStatus(e.countTotal, e.status);
        });
}